import React, { Component } from 'react';
import Swiper from 'swiper/js/swiper.js'
import 'swiper/css/swiper.min.css'
import Server from '../../common/server';
import './header.scss';
import utils from '../../common/utils';
class Header extends Component {
  constructor(props, context){
    super(props)
    this.state = {
      getWealSuccess: false, // 控制获取成功弹窗是否显示
      userChooseLevelWeal: false, // 控制选择领取的礼包的弹窗是否显示
      toastMessage: '', // toast 提示语
      wealId: '', // 礼品ID
      wealLevel: '', // 领取的礼品级别
      levelWealData: [],
      avatorbgIndex: 0,
      index: 0,
      progressBarStyle: {
        width: 0,
        transition: 'width 1.5s',
        WebkitTransition: 'width 1.5s ease'
      }
    }
  }
  componentDidMount() {
    let me = this
    let name = utils.getParamFromURL('name')
    let level = utils.getParamFromURL('level')
    if (name !== '' && level !== '') {
      Server.getWeal({
        level: level,
        name: name
      }, function (json) {
        switch (json.code) {
          case 200:
            me.props.resetData(true)
            me.setState({
              getWealSuccess: true,
              userChooseLevelWeal: false,
              wealId: name
            })
            document.getElementsByClassName('mask')[0].addEventListener("touchmove", (e) => {
              // 执行滚动回调
              this.sidebarTouchMove(e)
            }, {
              passive: false //  禁止 passive 效果
            })
            break;
          default:
            me.setState({
              userChooseLevelWeal: false,
              toastMessage: '领取失败, 请稍后再试'
            })
            break;
        }
      })
    }
  }
  // 计算页面UI上人数，如果超过万人，则需要显示 .xxw 不超过则需要直接显示
  handlePeopleCount(count) {
    if (count < 10000) {
      return count
    } else {
      return `${(count/10000).toFixed(2)}w`
    }
  }
  // 用户没有满级的状态
  notGetFullLevelHtmlTemplate(index, info) {
    // 计算用户进度条的距离
    this.setProgressLength(index, info)
    return <div className="status_un_lock">
      <img src={this.props.userStateImg[index].start} />
      <span>还差 <i>{this.props.difListenCount}min </i>即可LV.{this.props.level + 1} ,加油哦！</span>
      <div className="progress" style={this.state.progressBarStyle}>
        <div className="progress_bar" ></div>
        <img className="progress_bar_icon" src="http://ydschool-online.nos.netease.com/1571626595434dian.png" />
      </div>
      <div className={`status_un_lock_contect status_un_lock_contect${index + 1}`}>
        <p>{info.text}</p>
        <em>{this.handlePeopleCount(info.unlockCount)}人已解锁</em>
      </div>
    </div>
  }
  // 用户满级的状态
  getFullLevelHtmlTemplate(index, info) {
    return  <div className="status_un_lock">
      <img src={this.props.userStateImg[index].getFullLevel} />
      <span>解锁成功</span>
      <p className="desc">{info.text}</p>
      <div className={`get_weal get_weal${index + 1}`} onClick={() => this.getLevelWeal(index)}>马上领取</div>
    </div>
  }
  // 更改用户选择的
  handleChange(val) {
    let wealId = val
    if (wealId === this.state.wealId) {
      wealId = ''
    }
    this.setState({
        wealId: wealId
      }
    )
  }
  userChooseLevelWeal() {
    let levelWealData = this.state.levelWealData
    let title = ''
    if (this.state.wealLevel === 4) {
      title = '勤听者福利二选一！'
    } else if (this.state.wealLevel === 8) {
      title = '精听者福利二选一！'
    } else if(this.state.wealLevel === 12) {
      title = '毅力超群福利二选一！'
    }
    return <div className="choose_weal">
      <div className="mask"></div>
      <div className="to_choose_weal choose-weal">
        <div className="close" onClick={() => this.cancel()}></div>
        <p className="choose_weal_title alert-title">{title}</p>
        <span className="choose_weal_desc alert-desc">惊喜好书，您想听哪本？</span>
        <ul className="choose-division">
          {
            levelWealData.map((item, index) =>
              <li key={index.toString()} onClick={()=>this.handleChange(item.name)}>
                <img src={item.image}/>
                <p style={{color: `${item.name === this.state.wealId ? '#3465FF' : this.props.dark ? '#E1E2E6' : '#30353D'}`}}>{item.title}</p>
                {
                  this.state.wealId !== item.name
                  ? <img className="un_selected" src="https://ydschool-video.nosdn.127.net/1571822417474ic_unselecte%402x.png" />
                  : <img className="selected" src="https://ydschool-video.nosdn.127.net/1571822430311ic_selecte%402x.png" />
                }
              </li>
            )
          }
        </ul>
        {
          this.state.wealId === '' ? <div className="not_get_weal_button">立即领取</div> :
          <div className="get_weal_button" onClick={() => this.getWeal()}>立即领取</div>
        }
      </div>
    </div>
  }
  sidebarTouchMove(e) {
    e.preventDefault();
  }
  getLevelWeal(index) {
    let me = this
    let wealLevel = (index + 1) * 4
    let data = {
      level: wealLevel
    }
    Server.getLevelWeal(data, function (json) {
      if (json.code === 200) {
        me.setState({
          wealLevel: wealLevel,
          levelWealData: json.data,
          userChooseLevelWeal: true
        })
        document.getElementsByClassName('mask')[0].addEventListener("touchmove", (e) => {
          // 执行滚动回调
          me.sidebarTouchMove(e)
        }, {
          passive: false //  禁止 passive 效果
        })
      }
    })
  }
  getWeal() {
    let me = this
    Server.getWeal({
      level: me.state.wealLevel,
      name: me.state.wealId
    }, function(json){
      switch (json.code) {
        case 200:
          me.setState({
            getWealSuccess: true,
            userChooseLevelWeal: false
          })
          me.props.resetData(true)
          document.getElementsByClassName('mask')[0].addEventListener("touchmove", (e) => {
            // 执行滚动回调
            this.sidebarTouchMove(e)
          }, {
            passive: false //  禁止 passive 效果
          })
          break;
        default:
          me.setState({
            userChooseLevelWeal: false,
            toastMessage: '领取失败, 请稍后再试'
          })
          break;
      }
    })
  }
  setProgressLength(index, info) {
    if (this.state.progressBarStyle.width !== 0) return
    let difListenCount = this.props.difListenCount
    let levelTimeList
    switch (index) {
      case 0:
        if (this.props.level > 4) break
        // if (7 > 4) break
        // 用户达到1级需听力30分钟1级到2级需要60分钟，2级到3级需要180分钟， 3级到4级需要300分钟
        levelTimeList = [30, 60, 120, 120]
        // difListenCount 升到下一级还差多少分钟
        this.computeProgresslength(this.props.level, difListenCount, levelTimeList)
        // this.computeProgresslength(7, 120, levelTimeList)
        break;
      case 1:
        if (this.props.level > 8 || this.props.level < 4) break
        // 用户4级到5级需听力300分钟, 5级到6级需要300分钟，6级到7级需要600分钟， 7级到8级需要1500分钟
        levelTimeList = [300, 300, 600, 1500]
        this.computeProgresslength(this.props.level - 4, difListenCount, levelTimeList)
        // this.computeProgresslength(7 - 4, 1400, levelTimeList)
        break;
      case 2:
        if (this.props.level < 8) break
        // 用户8级需到9级听力3000分钟， 9级到10级需要6000分钟，10级到11级需要6000分钟，11级到12级需要12000分钟
        levelTimeList = [3000, 6000, 6000, 12000]
        this.computeProgresslength(this.props.level - 8, difListenCount, levelTimeList)
        break;
      default:
        break;
    }
  }
  computeProgresslength(userLevel, difListenCount, levelTimeList) {
    // 进度条每一个阶段的长度
    let level = userLevel
    let progressStepList = [74, 164, 164, 154]
    if (window.ydk.isIpad) {
      progressStepList = [88.8, 196.8, 196.8, 184.8]
    }
    let progresslength = 0
    for (let i = 0; i < progressStepList.length; i++) {
      if (level === 0) break
      progresslength = Number(progresslength) + Number(progressStepList[i])
      if ((level - 1) === i) break
    }
    if (levelTimeList[level] !== this.props.difListenCount) {
      progresslength = Number(progresslength) + ((Number(levelTimeList[level]) - Number(this.props.difListenCount)) / Number(levelTimeList[level])) * Number(progressStepList[level])
    }
    let animationTime
    if (userLevel === 0) {
      animationTime = 0.5
    }
    if (userLevel === 1 ) {
      animationTime = 1
    }
    if (userLevel > 1) {
      animationTime = 1.5
    }
    setTimeout(() => {
      if (window.ydk.isIpad) {
        this.setState({
          progressBarStyle: {
            width: `${progresslength/2}px`,
            transition: `width ${animationTime}s`,
            WebkitTransition: `width ${animationTime}s ease`
          }
        })
      } else {
        this.setState({
          progressBarStyle: {
            width: `${progresslength/100}rem`,
            transition: `width ${animationTime}s`,
            WebkitTransition: `width ${animationTime}s ease`
          }
        })
      }
    }, 1000);
  }
  cardStatusConponent(index, info) {
    let me = this
    if (info.status === 'LOCK') {
      return  <div className="status_lock">
        <img src={this.props.userStateImg[index].unStart} />
        <span>未开始，继续加油吧！</span>
        <p>{info.text}</p>
        <em>{this.handlePeopleCount(info.unlockCount)}人已解锁</em>
      </div>
    }
    if (info.status === 'UNLOCK') {
    // if (info.status === 'RECEIVED') {
      var HtmlTemplate
      switch (index) {
        case 0:
          if (me.props.level >= 4) {
          // if (6 >= 4) {
            HtmlTemplate = this.getFullLevelHtmlTemplate(index, info)
          } else {
            HtmlTemplate = this.notGetFullLevelHtmlTemplate(index, info)
          }
          break;
        case 1:
          if (me.props.level >= 8) {
          // if (10 >= 8) {
            HtmlTemplate = this.getFullLevelHtmlTemplate(index, info)
          } else {
            HtmlTemplate = this.notGetFullLevelHtmlTemplate(index, info)
          }
          break;
        case 2:
          if (me.props.level >= 12) {
          // if (12 >= 12) {
            HtmlTemplate = this.getFullLevelHtmlTemplate(index, info)
          } else {
            HtmlTemplate = this.notGetFullLevelHtmlTemplate(index, info)
          }
          break;
        default:
          break;
      }
      return HtmlTemplate
    }
    if (info.status === 'RECEIVED') {
    // if (info.status === 'LOCK') {
      return  <div className={`status_received${index + 1}`}>
        <img src={me.props.userStateImg[index].unlock} />
        <p>{info.text}</p>
        <a href={`yddict://youdao.com/listening?page=column&id=${info.receivedColumn}`}>立即查看</a>
      </div>
    }
  }
  getWealSuccess() {
    return <div className="get_weal_success">
      <div className="mask"></div>
      <div className="to_check_weal color-devider-1">
        <div className="get_success">
          <p className="alert-title">福利领取成功!</p>
          <span className="alert-desc">福利听力包可在“我的成就-我的福利”查看</span>
        </div>
        <div className="get_success_button alert-bg">
          <p className="alert-cancle" onClick={() => this.cancel()}>取消</p>
          <a className="color-text-confirm" onClick={()=> this.immediatelyCheck(this.state.wealId)}>立即查看</a>
        </div>
      </div>
    </div>
  } 
  immediatelyCheck(wealId){
    this.setState({
      getWealSuccess: false
    }, function () {
      window.location.href = `yddict://youdao.com/listening?page=column&id=${wealId}`
    })
  }
  toast(toastMessage) {
    setTimeout(() => {
      this.setState({
        toastMessage: ''
      })
    }, 1500);
    return <div className="toast">{toastMessage}</div>
  }
  cancel() {
    this.setState({
      getWealSuccess: false,
      userChooseLevelWeal: false
    })
  }
  
  initRender(level) {
    var me = this
    let slidesPerView = 1.08
    if (window.ydk.isIpad) {
      slidesPerView = 'auto'
    }
    let initialSlide = 0
    if (level >= 4) {
      initialSlide = 1
    }
    if (level >= 8) {
      initialSlide = 2
    }
    me.setState({
      avatorbgIndex: initialSlide
    })
    new Swiper('.swiper-container', {
      slidesPerView: slidesPerView,
      initialSlide: initialSlide,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      on: {
        slideChange: function () {
          me.setState({
            initialSlide: this.activeIndex,
            avatorbgIndex: this.activeIndex,
          })
        }
      },
    });
  }
  handleTouchMove = (e) => {
    e.preventDefault();
  };

  render() {
    return (
      <div className="header">
        <div className="avatar">
          {
            this.props.gradeInfo.length !== 0 && <img className="user_head_bg" src='http://ydschool-online.nos.netease.com/1571037520117blue%402x.png' style={{zIndex: `${this.state.avatorbgIndex === 0 && (this.props.gradeInfo[this.state.avatorbgIndex].status === 'LOCK') ? false : true ? '3' : '1'}`}} />
          }
          {
            this.props.gradeInfo.length !== 0 && <img className="user_head_bg" src='http://ydschool-online.nos.netease.com/1571218951689red%402x.png' style={{zIndex: `${this.state.avatorbgIndex === 1 && (this.props.gradeInfo[this.state.avatorbgIndex].status === 'LOCK' ? false : true) ? '3' : '1'}`}}/>
          }
          {
            this.props.gradeInfo.length !== 0 && <img className="user_head_bg" src='http://ydschool-online.nos.netease.com/1571218975991gold%402x.png' style={{zIndex: `${this.state.avatorbgIndex === 2 && (this.props.gradeInfo[this.state.avatorbgIndex].status === 'LOCK' ? false : true) ? '3' : '1'}`}}/>
          }
          {
            this.props.gradeInfo.length !== 0 && <img className="user_head_bg" src='http://ydschool-online.nos.netease.com/1574056348831gray%402x.png' style={{zIndex: `${(this.props.gradeInfo[this.state.avatorbgIndex].status === 'LOCK' ? true : false) ? '3' : '1'}`}}/>
          }
          <img className="user_head" src={this.props.avatar} />
          {
            this.props.vip && <img className="vip" src="http://ydschool-online.nos.netease.com/1574825675003vip.png" />
          }
        </div>
        <div className="swiper-container">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <div className="contact">
                {this.props.gradeInfo[0] && this.cardStatusConponent(0, this.props.gradeInfo[0])}
              </div>
            </div>
            <div className="swiper-slide">
              <div className="contact">
                {this.props.gradeInfo[1] &&this.cardStatusConponent(1, this.props.gradeInfo[1])}
              </div>
            </div>
            <div className="swiper-slide">
              <div className="contact">
                {this.props.gradeInfo[2] &&this.cardStatusConponent(2, this.props.gradeInfo[2])}
              </div>
            </div>
          </div>
        </div>
        {
          this.state.getWealSuccess && this.getWealSuccess()
        }
        {
          this.state.userChooseLevelWeal && this.userChooseLevelWeal()
        }
        {
          this.state.toastMessage !== '' && this.toast(this.state.toastMessage)
        }
      </div>
    );
  }
}

export default Header;
